var map = {
	"./about-background-phone.png": 6929,
	"./about-background.png": 3662,
	"./adv.png": 2433,
	"./aristone.png": 8222,
	"./bacs.png": 1803,
	"./camfil.png": 6039,
	"./cherbrooke.png": 8014,
	"./clivet.png": 7240,
	"./daikin.png": 3908,
	"./euroklimat.png": 7613,
	"./flaktwood.png": 3187,
	"./greenstandart.png": 9630,
	"./informteh.png": 7417,
	"./mitsubish.png": 6824,
	"./panasonic.png": 3726,
	"./remak.png": 5996,
	"./rusalumtrub.png": 8529,
	"./rusenergo.png": 6868,
	"./samsung.png": 70,
	"./sauermann.png": 3213,
	"./testo.png": 3254,
	"./unido.png": 7810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6467;